// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M11 7.83L6.1 12.73Q5.8 13.03 5.4 13.02T4.7 12.71Q4.42 12.41 4.41 12.01T4.7 11.31L11.3 4.71Q11.45 4.56 11.63 4.5T12 4.42 12.38 4.48 12.71 4.69L19.31 11.29Q19.59 11.57 19.59 11.98T19.31 12.69Q19.01 12.99 18.6 12.99T17.89 12.69L13 7.83V19Q13 19.42 12.71 19.71T12 20 11.29 19.71 11 19Z"/>';

/** Arrow Up (arrows). */
const icon: IconData = {
  id: "arrow-up",
  name: "Arrow Up",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M11 20V7.83L5.4 13.43 4 12 12 4 20 12 18.6 13.43 13 7.83V20Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M11 7.83L6.1 12.73Q5.8 13.03 5.4 13.02T4.7 12.71Q4.42 12.41 4.41 12.01T4.7 11.31L11.3 4.71Q11.45 4.56 11.63 4.5T12 4.42 12.38 4.48 12.71 4.69L19.31 11.29Q19.59 11.57 19.59 11.98T19.31 12.69Q19.01 12.99 18.6 12.99T17.89 12.69L13 7.83V19Q13 19.42 12.71 19.71T12 20 11.29 19.71 11 19Z"/></g><path d="M11 7.83L6.1 12.73Q5.8 13.03 5.4 13.02T4.7 12.71Q4.42 12.41 4.41 12.01T4.7 11.31L11.3 4.71Q11.45 4.56 11.63 4.5T12 4.42 12.38 4.48 12.71 4.69L19.31 11.29Q19.59 11.57 19.59 11.98T19.31 12.69Q19.01 12.99 18.6 12.99T17.89 12.69L13 7.83V19Q13 19.42 12.71 19.71T12 20 11.29 19.71 11 19Z"/>',
    },
  },
  animation: () => import("../animations/arrow-up.js"),
};

export default icon;
